import { render } from "./App.vue?vue&type=template&id=5dbb52af"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5dbb52af&lang=css"

import exportComponent from "/Users/alain/Documents/realWorldVue/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__